// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2D4oi","addWidgetButton":"Header_addWidgetButton__2kw2c","dashboardTabs":"Header_dashboardTabs__10bFZ","active":"Header_active__19n65"};